import Cropper from 'cropperjs';

import {
  Component,
  Input,
  OnInit,
  ViewChild,
  AfterViewInit,
  ElementRef,
  ChangeDetectorRef,
  EventEmitter,
  Output,
} from '@angular/core';

@Component({
  selector: 'sn-image-editor',
  templateUrl: './image-editor.component.html',
  styleUrls: ['./image-editor.component.scss'],
})
export class SnImageEditorComponent implements OnInit, AfterViewInit {
  @Input() public url: string;

  @Output() public readonly editedCanvas = new EventEmitter<HTMLCanvasElement>(null);

  @ViewChild('img') public img: ElementRef;

  public cropper: Cropper;

  public croppedPhoto: HTMLCanvasElement;
  public croppedUrl: string;

  public height: number;
  public width: number;

  constructor(private readonly _elementRef: ElementRef, private readonly _cd: ChangeDetectorRef) {}

  public ngOnInit(): void {}

  public ngAfterViewInit(): void {
    this._initCropper();
  }

  public crop(): void {
    if (!this.cropper) {
      return;
    }
    this.croppedPhoto = this.cropper.getCroppedCanvas({
      height: this.height,
      width: this.width,
    });
    this.croppedUrl = this.croppedPhoto.toDataURL();
    this.editedCanvas.next(this.croppedPhoto);
    this.cropper.destroy();
  }

  public undo(): void {
    this.croppedPhoto = null;
    this.editedCanvas.next(this.croppedPhoto);
    this._cd.detectChanges();
    this._initCropper();
  }

  private _initCropper(): void {
    const img: HTMLImageElement = this._elementRef.nativeElement.querySelector('img');
    img.onload = () => {
      const overlayHeight = document.querySelector('.cdk-overlay-container').clientHeight - 100;
      const overlayWidth = document.querySelector('.cdk-overlay-container').clientWidth - 100;
      this.height = Math.min(img.clientHeight, overlayHeight);
      this.width = Math.min(img.clientWidth, overlayWidth);
      this.cropper = new Cropper(this._elementRef.nativeElement.querySelector('img'), {
        viewMode: 1,
        autoCrop: true,
        dragMode: 'move',
        restore: true,
        checkOrientation: false,
        zoomOnTouch: true,
        zoomOnWheel: true,
        wheelZoomRatio: 0.5,
        guides: false,
        highlight: false,
      });
    };
  }
}
